/**
 * Created by mauget on 4/22/16.
 */

import _                from 'lodash';
import StringBuilder    from 'util/StringBuilder';
import {fromByteArray}  from 'base64-js';
import constants        from 'Constants.js';
import { v4 as uuidv4 } from 'uuid';

// Translation table: maps a hex printable char to binary, assumming a UTF-8 codepoint
const xl = {};
xl['0'] = 0;  xl['1'] = 1;  xl['2'] = 2;  xl['3'] = 3;  xl['4'] = 4;
xl['5'] = 5;  xl['6'] = 6;  xl['7'] = 7;  xl['8'] = 8;  xl['9'] = 9;
xl['a'] = 10; xl['b'] = 11; xl['c'] = 12; xl['d'] = 13; xl['e'] = 14; xl['f'] = 15;
xl['A'] = 10; xl['B'] = 11; xl['C'] = 12; xl['D'] = 13; xl['E'] = 14; xl['F'] = 15;

class GuidUtil {

    //==============================================================================
    // Returns a new verson 4 GUID / UUID.
    //==============================================================================
    get guid() { return uuidv4(); }

    //==============================================================================
    // Returns an encoded new verson 4 GUID / UUID.
    //==============================================================================
    get encodedGuid() { return this.encode(uuidv4()); }

    //==============================================================================
    // Decodes a GUID that was encoded without dashes. Those are re-insertered into
    // the cleartext output.
    //
    // Input eg: 'bUnZXQAAJ+wAAJdkAADyBw=='
    // Output eg: '6d49d95d-0000-27ec-0000-97640000f207'
    //==============================================================================
    decode( encodedGuid ){

        const b = window.atob( encodedGuid );
        const sd = b.split('').map(c => c.charCodeAt(0));
        const sb = new StringBuilder();
        sd.map( n  => sb.append(`${ ((n - n % 16) / 16).toString(16) }${(n % 16).toString(16)}` ));

        // Format: 8-4-4-4-12 hex nibbles
        const stanzas = [8, 4, 4, 4, 12];
        let offset = 0;

        const hexStr = sb.toString();
        sb.reset();
        _.forEach(stanzas, i => {
            if (offset) { sb.append( constants.STRING_DASH );  }
            sb.append( hexStr.slice(offset, offset += i) );
        });

        const guid = sb.toString();
        return guid;

    }

    //==============================================================================
    // Encodes a GUID that was formatted with dashes. Those are removed before
    // encoding.
    //
    // Input eg: '6d49d95d-0000-27ec-0000-97640000f207'
    // Output eg: 'bUnZXQAAJ+wAAJdkAADyBw=='
    //==============================================================================
    encode( formattedGuid ) {

        if (!formattedGuid || formattedGuid.length !== 36) {
            throw `clearTextFormattedGuid, ${formattedGuid}, is not in formatted GUID format`;
        }
        // 1. split on '-' into array of five stanzas. We omit the '-' in the encoded value.
        const ga = formattedGuid.toLowerCase().split( constants.STRING_DASH );

        // 2. Flatten stanza strings into single hex string
        const sb = new StringBuilder();
        _.forEach(ga, p => sb.append(p));
        const hexStr = sb.toString();

        // 3 Translate hex printable chars (UTF-8) into pure binary byte array
        const baLen = (hexStr.length+1) / 2;
        const byteArray = new Uint8Array( baLen );
        for( let i = 0; i < hexStr.length; i += 2 ){
            const n = hexStr.slice(i, i + 2);
            byteArray[ i/2 ] = xl[ n[0] ] << 4 | xl[ n[1] ]  ;
        }

        // 4. Base64 encode byte array
        const base64 = fromByteArray( byteArray );

        return base64;

    }

}

const guidUtil = new GuidUtil();
export default guidUtil;